import React, { useState, useEffect } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import {
  generate_professional_summary,
  clearPS,
  yof_success,
  personal_information
} from "../../../Redux/ActionCreator";
import {
  Deepseek_generate_professional_summary
} from "../../../Redux/DeepseekAI/index"
import { ToastContainer, toast } from "react-toastify";
import PencilLoader from "../../common/LoaderModal/PencilLoader";
// import { saveIntoServerCache, getTwoFromServerCache, getAllResumeDetailsInCache, getOneFromServerCache } from "../../../utils/saveIntoCache";


const Summary1 = ({ nextStep, prevStep, setStep }) => {
  const dispatch = useDispatch();
  const [ YOF, setYOF ] = useState(null);
  const [ showNextBtn, setShowNextBtn ] = useState(false);
  const activity = useSelector((act) => act.activities);
  const secret = useSelector((prev) => prev.secret);
  const skills = useSelector((skills) => skills.skills);
  const combined_skills = useSelector(e => e.combine_skills);  
  const info = useSelector((info) => info.personal_info);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  let yearOfExp = useSelector(e => e.yof);

  const [PsStat, setPsStat] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showHeading1, setShowHeading1] = useState(false);
  const [showHeading2, setShowHeading2] = useState(false);
  const [showJobTitle1, setShowJobTitle1] = useState(false);
  const [showJobTitle2, setShowJobTitle2] = useState(false);
  const [showJobTitle3, setShowJobTitle3] = useState(false);
  const [showGeneratingModal, setShowGeneratingModal] = useState(false);

  useEffect(() => {
    if ( info.message?.summaryClicked !== undefined ) {
      setShowNextBtn(true);
    }
    if (yearOfExp.message !== null) {
      setYOF(yearOfExp.message);
    }
    // Show first name label and input after delay (simulating onDone)
    const showshowHeading1Timeout = setTimeout(() => setShowHeading1(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(showshowHeading1Timeout);
  }, []);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    if (showHeading1 == true && YOF !== null) {
      const showshowHeading2Timeout = setTimeout(() => setShowHeading2(true), 500); // Matches Typewriter speed

      return () => clearTimeout(showshowHeading2Timeout);
    }
  }, [showHeading1, YOF]);

  useEffect(() => {
    // Show last name label and input once first name is being typed
    if (showJobTitle1 == true) {
      const showJobTitle1Timeout = setTimeout(() => setShowJobTitle1(true), 100);

      return () => clearTimeout(showJobTitle1Timeout);  
    }
  }, [showJobTitle1]); // Runs only when firstName updates


  useEffect(() => {
    if (showJobTitle2 == true) {
      // Show last name label and input once first name is being typed
      const showJobTitle2Timeout = setTimeout(() => setShowJobTitle2(true), 100);

      return () => clearTimeout(showJobTitle2Timeout);
    }
  }, [showJobTitle2]); // Runs only when firstName updates

  const handleGenerateSummary = () => {
    if ( info.message?.summaryClicked == undefined ) {
      setShowGeneratingModal(true);
      setShowNextBtn(true);
      setPsStat(true);
      dispatch(clearPS());
      const cred = {
        Experience: activity?.activities,
        Technical_skills: combined_skills?.skills,
        Language: flowLanguage || "English", // Language,
        CvType: info.message?.JobInterests[0].value !== undefined ? info.message?.JobInterests[0].value : info.message?.JobInterests[0],
        summary: "",
        type: "create professional summary"
      };
      let data = { ...info.message, summaryClicked: true }
      dispatch(personal_information(data));
      // console.log("executing professional summary generating process");
      // dispatch(generate_professional_summary(cred));
      dispatch(generate_professional_summary(cred));
      dispatch(yof_success(YOF));
      
      // Hide modal after a delay (simulate generation time)
      setTimeout(() => {
        setShowGeneratingModal(false);
      }, 3000);
    } else {
      setTimeout(() => {
        toast.error("Please, proceed to the next screen by clicking \"save\" button", {
            position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    }
    
  }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="4" current={false} label="Language" completed={true} />
            </div>
            <Tab num="4" current={false} label="Education" completed={true} />
            <Tab num="5" current={true} label="Professional Summary" completed={false} />
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          className='flex justify-center'
        >
          <h2 className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold mb-4 max-w-[500px] notranslate">
            {flowLanguage == "Spanish" ? (
              <Typewriter key={flowLanguage} words={["¡Casi terminamos! Refinemos tu perfil para que resaltes."]} loop={1} typeSpeed={40} />
            ) : (
              <Typewriter key={flowLanguage} words={["Almost done! Let's refine your profile so you stand out."]} loop={1} typeSpeed={40} />
            )}            
          </h2>
        </motion.div>
        {showHeading1 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            className=" flex justify-center mb-6"
          >
            <div>
              <label htmlFor="yof" className="block text-gray-700 mb-4 notranslate">
                {flowLanguage == "Spanish" ? (
                  <Typewriter key={flowLanguage} words={["¿Cuántos años de experiencia tienes en este campo?"]} loop={1} typeSpeed={40} />
                ) : (
                  <Typewriter key={flowLanguage} words={["How many years of experience do you have in this field?"]} loop={1} typeSpeed={40} />
                )}
                {/* <Typewriter words={["How many years of experience do you have in this field?"]} loop={1} typeSpeed={50} />  */}
              </label>
              <input 
                type="number" 
                id="yof" 
                placeholder={flowLanguage == "Spanish" ? (
                  "Por ejemplo: 9"
                ) : (
                  "For example: 9"
                )} 
                className="w-full max-w-[500px] border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent" 
                value={YOF} 
                onChange={(e) => setYOF(e.target.value)} 
              />
            </div>
          </motion.div>
        )}
        
        {showHeading2 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            className='flex items-center justify-center w-full'
          >
            <div >
              <p className="text-center max-w-[500px] text-gray-700 mb-8 notranslate">
                {flowLanguage == "Spanish" ? (
                  <Typewriter key={flowLanguage} words={["A continuación, haz clic en \"Crear Resumen\" y la IA de Moil lo hará automáticamente por ti, basándose en tus habilidades y experiencia."]} loop={1} typeSpeed={40} />
                ) : (
                  <Typewriter key={flowLanguage} words={["Next click \"create summary\" and Moil AI will automatically do it for you based on your skills and experience."]} loop={1} typeSpeed={40} />
                )}
                {/* <Typewriter words={["Next click \"create summary\" and Moil AI will automatically do it for you based on your skills and experience."]} loop={1} typeSpeed={50} />  */}
              </p>
            
              <div className='flex justify-center'>
                <button
                  onClick={handleGenerateSummary}
                  className={` max-w-max  text-white font-medium py-3 px-[20px] rounded-[50px] shadow-md  flex items-center justify-center text-xl ${ info.message?.summaryClicked !== undefined ? "bg-gray-500" : "bg-gradient-to-r from-[#FF6633] to-[#5843BD] hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300"}`}
                >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "CREAR RESUMEN"
                  ) : (
                    "CREATE SUMMARY"
                  )}
                </span>                  
                  <span className='ml-2'>
                    <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png" alt='Moil white logo' />
                  </span>
                </button>
              </div>
            </div>
          </motion.div>
        )}

        {/* Navigation Buttons */}
        <Footer nextStep={nextStep} prevStep={prevStep} showNext={showNextBtn} setPrevStep={true} setStep={setStep} />

      </div>
      
      {/* Generating Summary Modal */}
      {showGeneratingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl p-8 max-w-md w-full mx-4 text-center">
            <div className="mb-6 flex justify-center">
              <PencilLoader />
            </div>
            <h3 className="text-xl font-semibold text-[#5843BD] mb-4 notranslate" key={flowLanguage}>
              {flowLanguage === "Spanish" ? (
                "Generando tu resumen profesional..."
              ) : (
                "Generating your professional summary..."
              )}
            </h3>
            <p className="text-gray-600 text-base notranslate" key={flowLanguage}>
              {flowLanguage === "Spanish" ? (
                "La IA de Moil está creando un resumen personalizado basado en tu experiencia y habilidades."
              ) : (
                "Moil AI is creating a personalized summary based on your experience and skills."
              )}
            </p>
          </div>
        </div>
      )}
      
      <ToastContainer />
    </div>
  );
};

export default Summary1;
